import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorConnectorService {

  private isSessionExpired = false;

  private sessionExpiredSource = new Subject<boolean>();
  isSessionExpired$ = this.sessionExpiredSource.asObservable();

  constructor() { }

  getSessionExpiration(): boolean {
    return this.isSessionExpired;
  }

  setSessionExpiration(isSessionExpired: boolean): void {
    this.isSessionExpired = isSessionExpired;
    this.sessionExpiredSource.next(isSessionExpired);
  }
}
